'use client';

import { Button } from '@common/components';
import { SvgShare2 } from '@common/icon';

import { openShareDrawer } from '@/app/_components/GlobalModal/_components/ShareDrawer';

export const ShareButton = () => {
  return (
    <Button
      aria-label="공유하기"
      className="size-fit p-0"
      theme="sub-text"
      onClick={() => {
        openShareDrawer(location.href);
      }}
    >
      <SvgShare2 className="size-20 text-Gray-600" />
    </Button>
  );
};
